export default __webpack_public_path__ + "static/media/blank.2c7ebc17.jpg";